
import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import MemberBadge from "./MemberBadge.vue";
import { MemberId, Question } from "../models/Question";

type Prop<T> = () => T;

interface DataType {
  members: MemberId[];
}
interface MethodType {
  calcMembers: () => MemberId[];
  isFinished: () => boolean;
  clickGroup: () => void;
  clickChoice: () => void;
  prev: () => void;
  next: () => void;
}

interface ComputedType {}
interface PropType {
  question: Question;
  isFirst: boolean;
  isLast: boolean;
}

export default Vue.extend({
  name: "FormationQuiz",
  components: {
    MemberBadge,
  },
  props: {
    question: Object as Prop<Question>,
    isFirst: Boolean,
    isLast: Boolean,
  },
  data(): DataType {
    return {
      members: (this as any).calcMembers(),
    };
  },
  computed: {
  },
  watch: {
    question() {
      this.members = this.calcMembers();
    },
  },
  methods: {
    calcMembers(): MemberId[] {
      return Array.from(
        { length: 9 },
        (_, v) => ((v + 2) as MemberId),
      ).filter(vv => !this.question.isAdded(vv));
    },
    isFinished(): boolean {
      return this.members.length === 0;
    },
    clickGroup(memberId: MemberId) {
      this.question.remove(memberId);
      this.members.push(memberId);
    },
    clickChoice(memberId: MemberId) {
      this.question.add(memberId);
      this.members = this.members.filter(v => v !== memberId);
    },
    prev() {
      this.$emit("prev");
    },
    next() {
      this.$emit("next");
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, PropType>);
